import { Tooltip } from '@skupreme/shared/ui';
import { useCallback, useState } from 'react';
import type { ClippedHoverTextProps } from 'types/components/clipped-hover-text';

export function ClippedHoverText({
  name,
  maxWidth = 120,
}: ClippedHoverTextProps) {
  const [isOverflown, setIsOverflown] = useState(false);

  const measure = useCallback((node: HTMLSpanElement | null) => {
    if (node) {
      setIsOverflown(
        node.scrollHeight > node.clientHeight ||
          node.scrollWidth > node.clientWidth,
      );
    }
  }, []);

  const text = (
    <span
      ref={measure}
      className="sk:block sk:truncate"
      style={{ maxWidth: `${maxWidth}px` }}
    >
      {name}
    </span>
  );

  /* The tooltip's trigger is a tab stop, so text that fits stays out of the tab order. */
  return isOverflown ? <Tooltip content={name}>{text}</Tooltip> : text;
}
